import '../styles/ModalCambios.css';

export default function ModalCambios({ onClose }) {
  return (
    <div className="modal-overlay">
      <div className="modal-cambios">
        <h3>Novedades de la versión</h3>

        <ul className="lista-cambios">
          <li>Gestión por tablet:
            <ul>
              <li>Al dar de alta a nuevo paciente, elección tablet (a rellenar por el paciente) o manual (a rellenar por la clínica).</li>
              <li>En la ficha de paciente se habilita la opción "firmar consentimiento", dando a alegir el documento a firmar</li>
            </ul>
          </li>
          <li>Nuevo campo "Profesional" en historial clínico para añadir al profesional en cada actuación.</li>
          <li>Documentos paciente, ya se pueden descargar y comprobar los documentos del paciente.</li>
          <li>Se ha añadido el domicilio en la factura.</li>
          <li>Mejoras generales de uso en tablas con muchos datos.</li>
        </ul>

        <h4>Recordatorios</h4>
        <ul className="lista-recordatorios">
          <li>Introducir las citas en el calendario de la aplicación (no Google Calendar) para irse familiarizando.</li>
          <li>Cuando se pueda, guardar las imagenes de los pacientes en su historial.</li>
          <li>Para tratamientos por piezas, usar el odontograma siempre que sea posible.</li>
        </ul>

        <div className="modal-acciones">
          <button onClick={onClose}>Entendido</button>
        </div>
      </div>
    </div>
  );
}
